import { render, staticRenderFns } from "./TheContactModalComments.vue?vue&type=template&id=75293288&"
import script from "./TheContactModalComments.vue?vue&type=script&lang=js&"
export * from "./TheContactModalComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports